if (document.querySelector('.has-loader')) {

	setTimeout(function(){
		document.querySelector('body').classList.add('loaded');
	}, 2000);

	setTimeout(function(){
		document.querySelector('body').classList.add('hide-loader');
	}, 4800);

}
